/**
 * Based on: https://github.com/adobe/react-spectrum/blob/main/packages/%40react-spectrum/divider/src/Divider.tsx
 */
import React, { forwardRef } from 'react';
import clsx from 'clsx';
import { DOMProps } from '@react-types/shared';
import { Separator as RACSeparator } from 'react-aria-components';
import {
  SapphireStyleProps,
  useSapphireStyleProps,
  useThemeCheck,
} from '../../utils';
import { GlobalDomAttributes } from '../../utils/types';
import { filterDOMProps } from '@react-aria/utils';
import styles from '@danske/sapphire-css/components/separator/separator.module.css';

export interface SeparatorProps
  extends DOMProps,
    GlobalDomAttributes,
    SapphireStyleProps {
  /**
   * The orientation of the separator.
   *
   * @default 'horizontal'
   */
  orientation?: 'horizontal' | 'vertical';
}

export const Separator = forwardRef(function Separator(
  props: SeparatorProps,
  ref: React.ForwardedRef<HTMLElement>
) {
  useThemeCheck();
  const { orientation = 'horizontal', ...otherProps } = props;
  const { styleProps, filteredProps } = useSapphireStyleProps(otherProps);

  return (
    <RACSeparator
      ref={ref}
      {...filteredProps}
      {...filterDOMProps(props, { global: true })}
      style={styleProps.style}
      className={clsx(styles['sapphire-separator'], styleProps.className)}
      orientation={orientation}
    />
  );
});
